module.exports = __webpack_public_path__ + "static/media/present.b80463b1.svg";